import { setTerms } from './helpers';

export const setRoomsCount = setTerms('rooms_count');
